import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { usePoliceChartsDataContext } from './hooks/usePoliceChartsDataContext';

export const ByPoliceStationAnual = () => {
    const { chartData } = usePoliceChartsDataContext();

   

    const tableColumns = [
            {
                key: 'ano_estatistica',
                header: 'Ano',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'delegacia',
                header: 'Delegacia',
                headerStyle: { fontWeight: '500' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '500', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.byPoliceStationAnual || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.delegacias.map((delegacia) => ({
            ...delegacia,
            ano_estatistica: itemAno.ano_estatistica
        }));
    });

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={flattenedData}
                columns={tableColumns}
                title="Por Delegacias (Anual)"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="500px"
            />
        </div>
    );
};